import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/layouts/partials/sidebar/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0442e71b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0442e71b', __exports__)) {
    console.log('reload')
    api.reload('0442e71b', __exports__)
  }
  
}


export default __exports__